import React from 'react';
import ITranch from '@/finsight/domain/vo/Tranch/ITranch';
import { IRating } from '@/finsight/domain/vo/IRating';
import CurrencyCell from '../Cells/CurrencyCell';
import SizeCell from '../Cells/SizeCell';
import TenorCell from '../Cells/TenorCell';
import MaturityCell from '../Cells/MaturityCell';
import RankingCell from '../Cells/RankingCell';
import RatingAgencyCell from '../Cells/RatingAgencyCell';
import GuidanceCell from '../Cells/GuidanceCell';
import GuidanceIPTCell from '../Cells/GuidanceIPTCell';
import CouponTypeCell from '../Cells/CouponTypeCell';
import BenchmarkCell from '../Cells/BenchmarkCell';
import SpreadCell from '../Cells/SpreadCell';
import CouponCell from '../Cells/CouponCell';
import NICCell from '../Cells/NICCell';
import PriceCell from '../Cells/PriceCell';

import alignStyles from '@dealroadshow/uikit/core/styles/helpers/align.scss';

interface ITableRowProps {
  tranche: ITranch,
  ratingsMapping: IRating[],
  dealProductId?: string,
  rowIndex: number,
}

const TableRow = ({ tranche, ratingsMapping, dealProductId, rowIndex } : ITableRowProps) => (
  <tr>
    <CurrencyCell
      className={ alignStyles.alignLeft }
      rowIndex={ rowIndex }
      tranche={ tranche }
    />
    <SizeCell
      rowIndex={ rowIndex }
      tranche={ tranche }
    />
    <TenorCell
      rowIndex={ rowIndex }
      tranche={ tranche }
    />
    <MaturityCell
      rowIndex={ rowIndex }
      tranche={ tranche }
    />
    <RankingCell
      rowIndex={ rowIndex }
      tranche={ tranche }
    />
    { ratingsMapping.map((rating, index) => (
      <RatingAgencyCell
        /* eslint-disable-next-line react/no-array-index-key */
        key={ index }
        rating={ rating }
        rowIndex={ rowIndex }
        tranche={ tranche }
      />
    )) }
    <CouponTypeCell
      rowIndex={ rowIndex }
      tranche={ tranche }
    />
    <BenchmarkCell
      rowIndex={ rowIndex }
      tranche={ tranche }
    />
    <GuidanceIPTCell
      rowIndex={ rowIndex }
      tranche={ tranche }
    />
    <GuidanceCell
      rowIndex={ rowIndex }
      tranche={ tranche }
    />
    <SpreadCell
      rowIndex={ rowIndex }
      tranche={ tranche }
    />
    <CouponCell
      rowIndex={ rowIndex }
      tranche={ tranche }
      dealProductId={ dealProductId }
    />
    <NICCell
      rowIndex={ rowIndex }
      tranche={ tranche }
    />
    <PriceCell
      rowIndex={ rowIndex }
      tranche={ tranche }
    />
  </tr>
);

export default TableRow;
